import { WidgetStorageId } from '@/types/enums/WidgetStorageId';
import { QueryClient } from '@tanstack/react-query';
import { useAtom } from 'jotai';
import storage from 'local-storage-fallback';

import { WidgetCurrency } from './api/types';
import useWidgetCurrencies from './api/useWidgetCurrencies';
import { defaultCurrency, widgetCurrencyAtom } from './widgetCurrency';

const useWidgetCurrency = (queryClient?: QueryClient) => {
  const [widgetCurrencyState, setWidgetCurrencyState] =
    useAtom(widgetCurrencyAtom);
  const { loadCurrencies } = useWidgetCurrencies(queryClient);

  const initWidgetCurrency = async (preferedWidgetCurrencyCode?: string) => {
    const currenciesResponse = await loadCurrencies();

    if (currenciesResponse.isSuccess && currenciesResponse.data) {
      const supportedCurrencies = currenciesResponse.data?.currencies;

      const userCurrencyCode = storage.getItem(WidgetStorageId.WidgetCurrency);

      if (userCurrencyCode) {
        const userCurrency = supportedCurrencies.find(
          sc => sc.code === userCurrencyCode
        );

        if (userCurrency) {
          setWidgetCurrencyState({
            widgetCurrencies: supportedCurrencies,
            widgetCurrency: userCurrency
          });
          return;
        }
      }

      if (preferedWidgetCurrencyCode) {
        const hostCurrency = supportedCurrencies.find(
          sc => sc.code === preferedWidgetCurrencyCode
        );

        if (hostCurrency) {
          storage.setItem(
            WidgetStorageId.WidgetPreferredCurrency,
            preferedWidgetCurrencyCode
          );
          setWidgetCurrencyState({
            widgetCurrencies: supportedCurrencies,
            widgetCurrency: hostCurrency
          });
          return;
        }
      }

      setWidgetCurrencyState({
        widgetCurrencies: supportedCurrencies,
        widgetCurrency: defaultCurrency
      });
    } else {
      setWidgetCurrencyState({
        widgetCurrencies: [defaultCurrency],
        widgetCurrency: defaultCurrency
      });
    }
  };

  const setWidgetCurrency = (currency?: WidgetCurrency) => {
    if (currency) {
      storage.setItem(WidgetStorageId.WidgetCurrency, currency.code);
      setWidgetCurrencyState({
        widgetCurrencies: widgetCurrencyState.widgetCurrencies,
        widgetCurrency: currency
      });
    }
  };

  return {
    initWidgetCurrency,
    setWidgetCurrency,
    widgetCurrencies: widgetCurrencyState.widgetCurrencies,
    widgetCurrency: widgetCurrencyState.widgetCurrency
  };
};

export default useWidgetCurrency;
